import { handleCustomResponse } from "./response";

export const validateImageFile = (
  file,
  exactWidth = 500,
  exactHeight = 125,
  maxSize = 10 * 1024 * 1024
) => {
  return new Promise((resolve, reject) => {
    if (file.size > maxSize) {
      const message = "File size too large. Maximum 10MB allowed.";
      handleCustomResponse("error", message);
      reject(message);
      return;
    }

    const imageURL = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(imageURL);

      // Create canvas with desired dimensions
      const canvas = document.createElement("canvas");
      canvas.width = exactWidth;
      canvas.height = exactHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, exactWidth, exactHeight);

      // Convert canvas to blob
      canvas.toBlob((blob) => {
        if (!blob) {
          const message = "Image processing failed.";
      handleCustomResponse("error", message);
          reject(message);
          return;
        }

        // Create a new preview URL
        const resizedImageURL = URL.createObjectURL(blob);
        resolve(resizedImageURL);
      }, file.type || "image/png"); // Keep original type or fallback
    };

    img.onerror = () => {
      URL.revokeObjectURL(imageURL);
      const message = "Invalid image file.";
      handleCustomResponse("error", message);
      reject(message);
    };

    img.src = imageURL;
  });
};
